import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-datetime-picker',
    templateUrl: './datetime-picker.component.html',
    styleUrls: ['./datetime-picker.component.scss'],
})
export class DatetimePickerComponent implements OnInit {
    @Input() currentDate: Date = null;
    @Input() minDate: Date = null;
    @Output() applied = new EventEmitter<Date>();
    @Output() canceled = new EventEmitter<void>();

    selectedDateTime: Date;

    constructor() {}

    ngOnInit(): void {
        this.currentDate = new Date();
    }

    onValueChanged($event) {
        this.selectedDateTime = $event;
    }

    apply() {
        this.applied.emit(this.selectedDateTime);
    }

    cancel() {
        this.canceled.emit();
    }
}
